var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user.login)?_c('v-btn',{class:_vm.color,attrs:{"text":"","rounded":""},on:{"click":_vm.onLogout}},[_vm._v(" 로그아웃 ")]):_c('v-btn',{class:_vm.color,attrs:{"text":"","to":"/user/login","rounded":""}},[_vm._v(" 로그인 ")])}
var staticRenderFns = []

export { render, staticRenderFns }